Ext.define('SA.view.scatterplot.YAxisRenderer', {
    singleton: true,

    render(axis, cfg, scale, attribute) {
        var tickFormatter = SA.data.AttributesCache.getTickFormatter(scale.ticks(cfg.yAxisTickCount), attribute),
            builder = d3.axisLeft(scale).ticks(cfg.yAxisTickCount).tickFormat(tickFormatter);

        axis.selectAll('*').remove();

        axis.call(builder)
            .call(styleTicks)
            .call(styleDomain)
            .call(renderLabel);

        function renderLabel(axis) {
            var text = d3.select(SA.SvgTextRenderer.renderWidget(axis.node(), {
                    xtype: 'component',
                    html: Ext.String.htmlEncode(SA.data.AttributesCache.getLabel(attribute)),
                    style: cfg.getAxisTitleStyle(cfg.yAxisHeight)
                }));

            text.attr('transform', (_, i, els) => `translate(${-cfg.yAxisWidth - els[i].getBBox().height} ${cfg.yAxisHeight}) rotate(-90)`);
        }

        function styleTicks(axis) {
            axis.selectAll('.tick line')
                    .attr('stroke', cfg.axisStrokeColor)
                    .up()
                .selectAll('text')
                    .attr('fill', cfg.axisFontColor)
                    .style('font-family', cfg.fontFamily)
                    .style('font-size', `${cfg.axisFontSize}px`)
                    .style('font-variant', cfg.fontVariant)
                    .style('letter-spacing', `${cfg.letterSpacing}px`);
        }

        function styleDomain(axis) {
            axis.selectAll('.domain')
                .attr('stroke', cfg.axisStrokeColor);
        }
    }
});